// FNV-1a hashing — a byte-for-byte port of
// `tento/tento-event-classifier/src/model.rs` (`fnv1a` / `bucket`).
//
// The hash MUST match the Rust implementation exactly, because the
// trained weight matrix is indexed by `fnv1a(feature) % n_buckets`. Any
// divergence silently misroutes features into the wrong buckets and the
// predictions drift from the server's. Parity is asserted by
// `tests/event-classifier-parity.deno.test.ts`.
//
// Rust hashes the UTF-8 bytes of the string as an unsigned 32-bit
// integer with wrapping multiply. We reproduce that with `TextEncoder`
// (UTF-8 bytes), `Math.imul` (32-bit wrapping multiply) and `>>> 0`
// (coerce back to unsigned 32-bit after each step).

const FNV_OFFSET_32 = 0x811c9dc5;
const FNV_PRIME_32 = 0x01000193;

const ENCODER = new TextEncoder();

/** FNV-1a over the UTF-8 bytes of `s`, returned as an unsigned u32. */
export function fnv1a(s: string): number {
  const bytes = ENCODER.encode(s);
  let h = FNV_OFFSET_32 >>> 0;
  for (const byte of bytes) {
    h = (h ^ byte) >>> 0;
    h = Math.imul(h, FNV_PRIME_32) >>> 0;
  }
  return h >>> 0;
}

/** Feature bucket index: `fnv1a(s) % nBuckets`. */
export function bucket(s: string, nBuckets: number): number {
  return fnv1a(s) % nBuckets;
}
